import React, { useEffect, useState } from 'react';
import Button from '../../components/shared/custom-btn';
import CustomInput from '../../components/shared/custom-input';
import CustomReactSelect from '../../components/shared/custom-react-selector';
import CustomTextarea from '../../components/shared/custom-textarea';
// import DateTimeLocalInput from '../../components/shared/datetime-input';
import { RxCross2 } from 'react-icons/rx';
import TabToggle from '../../components/shared/tab-toggle';
import ModalHeading from '../../components/shared/modal-heading';
import { prependDefault } from '../../utils/structure-options-utils';
import { createTire } from '../../services/tires-service';
import { ApiResponseMessage } from '../../components/shared/api-response';
import Loader from '../../components/shared/loader';

const AddModal = ({ handleCloseAddModal, loadingGlobalData, fetchGlobalData, onAdd, openEditModal, accountId, vendors, seasons, brands, positions, sizes, vehicles, isVehicleEditable = true }) => {
    const [formData, setFormData] = useState({
        // time: '',
        brand: '',
        model: '',
        vendorId: '',
        tin: '',
        size: '',
        season: '',
        rim: true,
        // vehicle: '',
        // position: '',
        note: '',
        receiptImage: null,
    });

    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState({ message: '', type: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setApiResponse({ message: '', type: '' });
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption ? selectedOption.value : ''
        }));
        setApiResponse({ message: '', type: '' });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (loading || apiResponse.type === 'success') return;
        setLoading(true);
        setApiResponse({ message: '', type: '' });

        try {
            const tireData = {
                brand: formData.brand,
                model: formData.model,
                vendorId: formData.vendorId,
                tin: formData.tin,
                size: formData.size,
                season: formData.season,
                rim: formData.rim,
                note: formData.note,
                // Include other fields as needed by your API
            };

            const response = await createTire(tireData, accountId);
            console.log(response);

            if (response.success) {
                setApiResponse({
                    message: 'Tire created successfully!',
                    type: 'success'
                });
                const newItem = response.data.data;
                onAdd?.(newItem);
                setTimeout(() => {
                    handleCloseAddModal();
                }, 1000);
                openEditModal?.(newItem);
            } else {
                setApiResponse({
                    message: response.data.message || 'Failed to create tire',
                    type: 'error'
                });
            }
        } catch (error) {
            setApiResponse({
                message: error.message || 'An unexpected error occurred',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    // const vehicleOptions = prependDefault(vehicles.map(v => ({ value: v.vehicleId, label: v.label })), 'Vehicle');
    const sizeOptions = prependDefault(sizes.map(v => ({ value: v.slug, label: v.label })), 'Size');
    const brandOptions = prependDefault(brands.map(v => ({ value: v.slug, label: v.label })), 'Brand');
    // const positionOptions = prependDefault(positions.map(v => ({ value: v.slug, label: v.label })), 'Position');
    const seasonOptions = prependDefault(seasons.map(v => ({ value: v.slug, label: v.label })), 'Season');
    const vendorOptions = prependDefault(vendors.map(v => ({ value: v.vendorId, label: v.label })), 'Vendor');


    useEffect(() => {
        fetchGlobalData();
    }, [])

    return (
        <form onSubmit={handleSave} className="space-y-2 pt-3 relative">
            <ModalHeading className="text-left mb-3 border-b border-gray-300 px-4 pb-2">Add Tire Detail</ModalHeading>

            <button
                className="hover:scale-105 absolute -top-2 right-2 bg-white border p-2 rounded-full"
                onClick={handleCloseAddModal}
                disabled={loading}
            >
                <RxCross2 className="text-xl" />
            </button>

            <ApiResponseMessage response={apiResponse} />

            {
                loadingGlobalData ?
                    <Loader />
                    :
                    <>
                        <div className="grid grid-cols-1 sm:grid-cols-2 px-4 gap-y-1.5 gap-x-2">

                            {/* <DateTimeLocalInput
                    label="Time"
                    name="time"
                    value={formData.time}
                    onChange={handleChange}
                    required={true}
                /> */}

                            <CustomReactSelect
                                label="Vendor"
                                name="vendorId"
                                value={vendorOptions.find(opt => opt.value === formData.vendorId)}
                                onChange={handleSelectChange}
                                placeholder='Select vendor'
                                options={vendorOptions}
                                isDisabled={loading}
                            />

                            {/* <CustomReactSelect
                    label="Vehicle"
                    name="vehicle"
                    value={vehicleOptions.find(opt => opt.value === formData.vehicle)}
                    onChange={handleSelectChange}
                    options={brandOptions}
                /> */}

                            <CustomReactSelect
                                label="Brand"
                                name="brand"
                                value={brandOptions.find(opt => opt.value === formData.brand)}
                                onChange={handleSelectChange}
                                placeholder='Select brand'
                                options={brandOptions}
                                required={true}
                                isDisabled={loading}
                            />

                            {/* <CustomReactSelect
                    label="Position"
                    name="position"
                    value={positionOptions.find(opt => opt.value === formData.position)}
                    onChange={handleSelectChange}
                    options={brandOptions}
                /> */}


                            <CustomInput
                                label="Model"
                                name="model"
                                type="text"
                                value={formData.model}
                                onChange={handleChange}
                                inputStyle="!py-[3px]"
                                labelGap="!gap-0.5"
                                labelStyle="text-gray-700"
                                required={true}
                                disabled={loading}
                            />

                            <CustomInput
                                label="TIN"
                                name="tin"
                                type="text"
                                value={formData.tin}
                                onChange={handleChange}
                                inputStyle="!py-[3px]"
                                labelGap="!gap-0.5"
                                labelStyle="text-gray-700"
                                required={true}
                                maxLength={14}
                                disabled={loading}
                            />

                            <div className='flex items-center gap-2'>
                                <CustomReactSelect
                                    label="Size"
                                    name="size"
                                    value={sizeOptions.find(opt => opt.value === formData.size)}
                                    onChange={handleSelectChange}
                                    options={sizeOptions}
                                    placeholder='Select size'
                                    required={true}
                                    isDisabled={loading}
                                />
                                <div className="flex flex-col gap-0.5 ">
                                    <label className="block text-sm text-gray-700">RIM</label>
                                    <TabToggle
                                        options={[
                                            { label: 'Yes', value: true },
                                            { label: 'No', value: false }
                                        ]}
                                        className={'!w-10'}
                                        selected={formData.rim}
                                        onChange={(val) => setFormData(prev => ({ ...prev, rim: val }))}
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <CustomReactSelect
                                label="Season"
                                name="season"
                                value={seasonOptions.find(opt => opt.value === formData.season)}
                                onChange={handleSelectChange}
                                options={seasonOptions}
                                placeholder='Select season'
                                isDisabled={loading}
                            />






                            <div className="sm:col-span-2">
                                <CustomTextarea
                                    label="Note"
                                    name="note"
                                    value={formData.note}
                                    onChange={handleChange}
                                    placeholder=""
                                    rows={2}
                                    labelStyle="text-gray-700"
                                    maxLength={500}
                                    disabled={loading}
                                />
                            </div>

                        </div>

                        <div className="flex justify-end px-4">
                            <Button
                                label={loading ? 'Saving...' : 'Save'}
                                type="submit"
                                className="bg-btnBg rounded-lg !py-1 text-white"
                                disabled={loading || apiResponse.type === 'success'}
                                loading={loading}
                            />
                        </div>
                    </>
            }


        </form>
    );
};

export default AddModal;